<script>
import TextInput from "@/components/TextInput";
import SubmitButton from "@/components/SubmitButton";
import Button from "@/components/Button";
import features from "@/configs/features";
import bus from "@/bus";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { useUserStore } from "../../stores/user";

export default {
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  components: {
    TextInput,
    SubmitButton,
    Button,
    ErrorMessage,
  },
  data() {
    return {
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      loadingState: 0,
      editError: null,
    };
  },
  computed: {
    features: () => features,
  },
  methods: {
    async modifyUser() {
      this.loadingState = 1;
      const { firstname, lastname, email, phone } = this;

      const error = await this.userStore.modify({
        firstname,
        lastname,
        email,
        phone,
      });
      this.loadingState = 2;
      if (error) {
        const {
          status,
          data: { message },
        } = error;
        this.editError = {
          status,
          message,
        };
      } else {
        bus.emit("closeModal");
      }
    },
    modifyPassword() {
      bus.emit("openModal", {
        modal: "modifyPassword",
      });
    },
  },
};
</script>

<template>
  <div
    class="p-8 z-50 bg-white shadow-xl rounded sm:min-w-md sm:max-w-2xl max-h-screen overflow-y-auto"
  >
    <h2 class="text-3xl font-light text-lightGrey mb-4">
      {{ $t("views.modals.edit_user_data.title") }}<br />
      <span class="text-base font-normal leading-tight">{{
        $t("views.modals.edit_user_data.question")
      }}</span>
    </h2>

    <ErrorMessage
      v-if="editError"
      :value="editError.message"
      @input="editError = null"
    />

    <form
      class="flex flex-col lg:flex-row flex-wrap mb-4"
      data-cy="modifyUserForm"
      @submit.prevent="modifyUser()"
    >
      <TextInput
        id="nom"
        v-model="lastname"
        data-cy="modifyLastname"
        :label="$t('views.modals.edit_user_data.last_name')"
        type="text"
        class="w-full lg:w-1/2 mb-4 flex-shrink-0 lg:pr-2"
        :required="false"
      />
      <TextInput
        id="prenom"
        v-model="firstname"
        data-cy="modifyFirstname"
        :label="$t('views.modals.edit_user_data.first_name')"
        type="text"
        class="w-full lg:w-1/2 mb-4 flex-shrink-0 lg:pl-2"
        :required="false"
      />
      <TextInput
        id="telephone"
        v-model="phone"
        data-cy="modifyPhone"
        :label="$t('views.modals.edit_user_data.phone')"
        type="tel"
        class="w-full lg:w-1/2 mb-4 flex-shrink-0 lg:pr-2"
        :required="false"
      />
      <TextInput
        id="mail"
        v-model="email"
        data-cy="modifyEmail"
        :label="$t('views.modals.edit_user_data.email')"
        type="email"
        class="w-full lg:w-1/2 mb-4 flex-shrink-0 lg:pl-2"
        :required="false"
      />
      <div class="w-full flex flex-col justify-start items-end">
        <SubmitButton v-model="loadingState" class="mb-2" />
        <Button
          bg="airbnbBlue"
          data-cy="modifyPasswordButton"
          @click="modifyPassword"
        >
          {{ $t("views.modals.edit_user_data.password") }}
        </Button>
      </div>
    </form>
  </div>
</template>

<style></style>
